import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Button, DialogActions } from '@mui/material';
import React, { ReactNode } from 'react';

import { useModalClose } from '../../hooks';

interface IProps {
  onClose: () => void;
  isBackButtonVisible: boolean;
  onBack: () => void;
  isImportStep: boolean;
  onNext: () => void;
  isNextButtonDisabled: boolean;
  isCancelButtonVisible: boolean;
  toast?: ReactNode;
}

const ModalFooter: React.FC<IProps> = ({
  onClose,
  isBackButtonVisible,
  onBack,
  isImportStep,
  onNext,
  isNextButtonDisabled,
  isCancelButtonVisible,
  toast,
}) => {
  const handleClose = useModalClose({ onClose });

  return (
    <DialogActions
      sx={{ justifyContent: isCancelButtonVisible ? 'space-between' : 'flex-end', px: 3, py: 3, position: 'relative' }}
    >
      {isCancelButtonVisible && (
        <Button
          onClick={onClose}
          sx={{ fontWeight: (theme) => theme.typography.fontWeightMedium, height: 30 }}
          data-action="cancel_modal_btn"
        >
          Cancel
        </Button>
      )}
      <Box>
        {isBackButtonVisible && (
          <Button
            onClick={onBack}
            variant="text"
            startIcon={<ChevronLeftIcon />}
            sx={{ mr: 2, height: 30 }}
            data-action="back_modal_btn"
          >
            Back
          </Button>
        )}
        <Button
          onClick={isImportStep ? handleClose : onNext}
          variant="contained"
          endIcon={!isImportStep ? <ChevronRightIcon /> : undefined}
          disabled={isNextButtonDisabled}
          sx={{ height: 30 }}
          data-action={isImportStep ? 'finish_modal_btn' : 'next_modal_btn'}
        >
          {isImportStep ? 'Finish' : 'Next'}
        </Button>
      </Box>
      {toast}
    </DialogActions>
  );
};

export default ModalFooter;
